export const CONSTANTS = [1, 2, 3];
export const WORKSPACE_SELECTOR = "WorkspaceSelector";
export const DIVIDER = "DIVIDER";
